// Colours
import { emeraldGreen, textGrey } from "Constants/ColourConstants";

// Common
import { styles as textStyles } from "Common/Styles/TextStyles";

export const styles = {
  headerBox: {
    display: "flex",
    justifyContent: "center",
    px: 2,
    mt: { xs: "0", sm: "4vh" },
  },
  title: {
    ...textStyles.poppinsTitle,
    fontSize: { xs: "2rem", sm: "2.5rem", lg: "3.5rem" },
  },
  manitobaLogo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "2rem",
    marginTop: "1rem",
  },
  footerBox: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    py: 1,
  },
  techSupport: {
    fontSize: 16,
    fontWeight: "medium",
    color: textGrey,
  },
  email: {
    color: emeraldGreen,
    fontWeight: "bold",
  },
  versionLanguageBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    mt: 2,
    alignItems: "center",
  },
  version: {
    opacity: 0.6,
    pl: 2,
  },
  language: {
    ml: 1,
    mr: 0.5,
  },
  iconButton: { borderRadius: 30 },
  otpBox: {
    alignItems: "center",
    gap: 2,
  },
  otpInput: {
    display: "flex",
    flexDirection: "row",
    maxWidth: "25rem",
    minWidth: "17rem",
    gap: { xs: 1, sm: 2 },
  },
  otpButtonsBox: {
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    flexDirection: "row",
  },
};
